import { render, staticRenderFns } from "./HomeSideBanner.vue?vue&type=template&id=954022ce&"
import script from "./HomeSideBanner.vue?vue&type=script&lang=js&"
export * from "./HomeSideBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports